import { SubtenantDto } from '@lmt/shared-types';
import { useSubtenants } from '@lmt/unicorn-shared/app/features/subtenants/selectors';
import { useUniSelector } from '@lmt/unicorn-shared/app/store/types';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import React, { FC, useState } from 'react';
import { MultiSelectDropDownInput } from '../../../common/ui-kit/inputs/dropdown/MultiSelectDropDownInput';

import styles from './SubtenantsFilter.module.scss';

interface Props {
  selectedSubtenants: SubtenantDto[];
  changeFilter: (subtenants: SubtenantDto[]) => void;
  disabled?: boolean;
}

export const SubtenantsFilter: FC<Props> = React.memo(function SubtenantsFilter(
  props,
) {
  const i18next = useScopedTranslation('subtenants_filter');
  const subtenants: SubtenantDto[] = useSubtenants();
  const [selectedSubtenants, setSelectedSubtenants] = useState(
    props.selectedSubtenants,
  );
  return (
    <div className={styles.container} data-test-id="subtenantFilter">
      <MultiSelectDropDownInput
        options={subtenants}
        idFunction={'name'}
        getOptionLabel={'name'}
        placeholder={i18next.t('subtenants_select')}
        allSelectedLabel={i18next.t('subtenants_all')}
        onValueChanged={(value) => {
          props.changeFilter(value as any);
          setSelectedSubtenants(value as any);
        }}
        values={selectedSubtenants.map((subtenant) => subtenant.name)}
        postfixRenderer={(subtenant) => (
          <span className={styles.code}>{subtenant?.code}</span>
        )}
        headerTitle={i18next.t('subtenants')}
      />
    </div>
  );
});
